export default class NewsdicService {
  getAll() {
    return fetch("https://api.tradersr.com/api/newsdic")
      .then(res => res.json());
  }  
}